module.exports = __webpack_public_path__ + "static/img/1.30f580a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/1.png
// module id = XEZf
// module chunks = 0